export default {
  setHost ({ commit }, host) {
    commit('setHost', host)
  },

  hideNavbar ({ commit }, slug) {
    commit('setHideNavbar', slug)
  },

  hideFooter ({ commit }, slug) {
    commit('setHideFooter', slug)
  },

  showSnackbar ({ commit }, { text, color, timeout, vertical }) {
    commit('showSnackbar', { text, color, timeout, vertical })
  },

  showSnackbarMaybe ({ commit }, type) {
    commit('showSnackbarMaybe', type)
  },

  async getAndSetDifferenceToServerTime ({ commit }) {
    const that = this
    await that.$axios.post('/public/time', {}).then((response) => {
      commit('setDifferenceToServerTime', {
        serverTime: response.data,
        responseTime: response.responseTime
      })
    })
  }

}
